import Marquee from "react-fast-marquee";

const WORDS = ["Concrete", "Renovation", "Snow Removal", "Construction"];

export const MarqueeStrip = () => (
  <div className="border-y border-[#262626] bg-[#050505] py-6 md:py-8 overflow-hidden" data-testid="marquee-strip">
    <Marquee speed={32} gradient={false} pauseOnHover>
      {[...WORDS, ...WORDS, ...WORDS].map((w, i) => (
        <span key={i} className="flex items-center shrink-0">
          <span
            className={`font-oswald font-bold uppercase tracking-tight text-4xl sm:text-6xl lg:text-7xl ${
              i % 2 === 0 ? "text-outline" : "text-[#F2F2F2]"
            }`}
          >
            {w}
          </span>
          <span className="mx-10 md:mx-16 h-3 w-3 md:h-4 md:w-4 rotate-45 bg-[#FF3B00] shrink-0" />
        </span>
      ))}
    </Marquee>
  </div>
);
